import { AxiosResponse } from 'axios';

export default (response: AxiosResponse<{ result: { id: number } }>) => ({
  addressID: response.data?.result?.id,
});
